// extracted by mini-css-extract-plugin
module.exports = {"attributeTag":"attributeTag_attributeTag__TPJkV","attributeTagLink":"attributeTag_attributeTagLink__63VpG"};